module.exports = __webpack_public_path__ + "img/bars-progress.55287bad.svg";